export default {
    Platform: parseInt(process.env.VUE_APP_PLATFORM),
}
